import React from 'react';

import type {AvatarProps} from '../../Avatar';
import {Avatar} from '../../Avatar';

import {useAvatarReactSelect} from './context';

const SIZES = {
  sm: `xs`,
  md: `xs`,
  lg: `sm`,
} as const;

export const SelectAvatar = (props: AvatarProps) => {
  const {size} = useAvatarReactSelect();
  const sizeProps = typeof size === `string` && size in SIZES ? SIZES[size] : `xs`;
  return <Avatar size={sizeProps} {...props} />;
};
